export const bookingDialogActions = {
  confirm: {
    title: "Confirm Booking", buttonTitle: "Yes, confirm booking",
    color: "success", status: "confirmed",
  },
  cancel: {
    title: "Cancel booking", buttonTitle: "Yes, cancel booking",
    color: "danger", status: "cancelled",
    reasonKey: "cancellation_reason", reasonLabel: "Cancellation Reason",
  },
  reschedule: {
    title: "Reschedule booking", buttonTitle: "Confirm reschedule",
    color: "primary-button",
    reasonKey: "reschedule_reason", reasonLabel: "Reason for Reschedule",
  },
  complete: {
    title: "Mark as Completed", buttonTitle: "Mark as completed",
    color: "success", status: "completed",
  },
  reopen: {
    title: "Re-open booking", buttonTitle: "Re-open booking",
    color: "primary-button", status: "pending",
    reasonKey: "reopening_reason", reasonLabel: "Reason for Re-opening",
  },
};

export const bookingActionTypes = {
  confirmed: "confirm", cancelled: "cancel", reschedule: "reschedule",
  completed: "complete", pending: "reopen",
};

export const packageDeleteDialogAction = {
  title: "Delete package", buttonTitle: "Delete permanently", color: "danger",
};

// Fallback choices until the backend supplies its reason lists.
export const bookingReasonOptions = [
  { value: "booking_cancelled_by_mistake", label: "Booking cancelled by mistake" },
  { value: "customer_request", label: "Customer request" },
  { value: "cancellation_reserved", label: "Cancellation reserved" },
  { value: "administrative_correction", label: "Administrative correction" },
  { value: "other", label: "Other" },
];
export const cancellationReasonOptions = [
  { value: "patient_requested_cancellation", label: "Patient requested cancellation" },
  { value: "patient_booked_the_wrong_type", label: "Patient booked the wrong type" },
  { value: "duplicate_booking", label: "Duplicate booking" },
  { value: "booking_information_is_incorrect", label: "Booking information is incorrect" },
  { value: "other", label: "Other" },
];

export function newBookingDialogValues() {
  return {
    appointment_date: "", appointment_time: "", internal_note: "",
    cancellation_reason: "", reschedule_reason: "", reopening_reason: "",
  };
}

export function bookingDialogPayload(type, values = {}, management = {}) {
  const config = bookingDialogActions[type];
  if (!config) return {};
  const data = {
    assigned_department_email: management.assigned_department_email || "",
    assigned_admin_id: management.assigned_admin_id === "" ? null : management.assigned_admin_id,
    follow_up_at: management.follow_up_at || "",
  };
  if (type === "reschedule" && values.appointment_date) {
    const time = values.appointment_time || "00:00";
    data.scheduled_at = `${values.appointment_date} ${time.length === 5 ? `${time}:00` : time}`;
  }
  if (config.reasonKey) {
    if (values[config.reasonKey]) data.reason_code = values[config.reasonKey];
  }
  if (values.internal_note) data.internal_note = values.internal_note;
  return data;
}
